$(document).ready(function () {
    const filemanager = document.querySelector('#filemanager');
    const supportedAnalysisColumns = (filemanager?.dataset.analysisColumns || '')
        .split(',')
        .filter(Boolean);

    // Capture phase: the side panel's own (jQuery, bubbling) click handler reads data-route, so the
    // selected file ids have to be on the trigger before that handler runs.
    document.addEventListener('click', function (event) {
        const trigger = event.target.closest('[data-file-analysis-action]');

        if (!trigger) {
            return;
        }

        const $trigger = $(trigger);
        const selectedIds = selectedFileIds();

        if (!selectedIds.length) {
            event.preventDefault();
            event.stopImmediatePropagation();
            alert($trigger.data('select-message'));
            return;
        }

        if ($trigger.data('file-analysis-action') === 'panel') {
            const panelRoute = $trigger.data('analysis-route') + '?analysis_file_ids=' + selectedIds.join(',');

            $trigger.attr('data-route', panelRoute).data('route', panelRoute);
            return;
        }

        event.preventDefault();

        const uploadRoute = $trigger.data('upload-route');
        const confirmText = $trigger.closest('.nc-table-select')
            .data('confirm-selection')
            .replace(/\(\d+/, '(' + selectedFileCount(selectedIds));

        confirm(confirmText, function () {
            submitDirectAnalysis(uploadRoute, selectedIds);
        });
    }, true);

    function selectedFileCount(selectedIds) {
        const allFilesNotice = document.getElementById('select-all-files');

        return selectedIds.some((id) => String(id).startsWith('all-files-')) && allFilesNotice
            ? Number(allFilesNotice.dataset.total)
            : selectedIds.length;
    }

    function selectedFileIds() {
        return $('.fileshandler tr.selected input.row-select')
            .map(function () {
                const value = $(this).val();

                if (typeof value !== 'string') {
                    return null;
                }

                // "All files in this folder" is sent as a token that the server expands.
                if (value.startsWith('all-files-')) {
                    return value;
                }

                return value.startsWith('file-') ? value.replace('file-', '') : null;
            })
            .get()
            .filter(Boolean);
    }

    function submitDirectAnalysis(route, selectedIds) {
        const requestBody = new URLSearchParams();

        selectedIds.forEach(function (fileId) {
            requestBody.append('analysis_file_ids[]', fileId);
        });

        supportedAnalysisColumns.forEach(function (column) {
            requestBody.append('columns[]', column);
        });

        fetch(route, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
            },
            body: requestBody,
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Analysis request failed');
                }

                return response.json();
            })
            .then(function (data) {
                window.location.href = data.routeReloadPage;
            })
            .catch(function () {
                alert($('[data-file-analysis-action="direct"]').data('error-message'));
            });
    }
});
